import { TILES_CARD } from "pages/useTileSize";
import { css } from "styled-components/macro";
import CardWithControls from "components/Dashboard/CardWithControls/CardWithControls";
import GroupTilesPanel from "../../../../components/Dashboard/Tiles/GroupTile/GroupTilesPanel";
import { GroupTilesFilterControls } from "../GroupTilesFilterControls";

export function GroupTilesPanelCard() {
  return (
    <CardWithControls
      title=""
      forceExpanded={true}
      className={`cardItem ${TILES_CARD}`}
      customCss={css`
        margin-top: 16px !important;
        padding: 0 16px !important;
        .MuiFormControl-root > .MuiInputBase-root {
          padding-right: 6px !important;
        }
      `}
    >
      <GroupTilesFilterControls />
      <GroupTilesPanel />
    </CardWithControls>
  );
}
